import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';
import { SectionInterface } from '../interfaces/section-interface';
import { AssetPathService } from '../../../../../projects/platform-manager/src/public_api';

@Injectable({
  providedIn: 'root'
})
export class HelpCenterService {
  displayHelpCenter = false;
  readonly toggledHelpCenterEvent = new EventEmitter<boolean>();

  constructor(
    private httpClient: HttpClient,
    private translateService: TranslateService,
    private assetPathService: AssetPathService
  ) {}

  toggleHelpCenter() {
    this.displayHelpCenter = !this.displayHelpCenter;
    this.toggledHelpCenterEvent.emit(this.displayHelpCenter);
  }

  getAllSections() {
    return this.httpClient
      .get<{ FAQ: SectionInterface[] }>(this.getAssetFilePath())
      .pipe(map(data => ({ sections: data.FAQ })));
  }

  private getAssetFilePath(): string {
    return this.assetPathService.getAssetsPath(
      `${this.translateService.currentLang}.json`,
      true,
      false,
      '/assets/faq'
    );
  }
}
